import { Fragment, useMemo } from "react";
import Breadcrumbs from "../components/breadcrumbs";
import Header from "../components/header";
import Steps from "../components/steps";
import { getDayDesc, getTicketDesc, slugifyEventTitle } from "../utils/utility";
import { useListaAcquisti } from "../hooks/useQueryCart";
import Icon from "../components/icons";
import { useNavigazione } from "../context/navigazione";
// import { usePdfAbbonamentoOpen } from "../hooks/usePdf";
import PdfButton from "../components/pdf-button";
import { Link } from "react-router-dom";

const Ordini = () => {
  const { getPathByTemplate } = useNavigazione();
  const bigliettiPrenotazioniLink = getPathByTemplate("bigliettiPrenotazioni");
  const breadcrumbs = useMemo(() => {
    return [
      {
        label: "Home",
        link: "/",
      },
      {
        label: "Biglietti e prenotazioni",
        link: bigliettiPrenotazioniLink,
      },
      {
        label: "I tuoi ordini",
      },
    ];
  }, [bigliettiPrenotazioniLink]);
  const { data: ordini, isLoading } = useListaAcquisti();
  const linkProgramma = getPathByTemplate("programma");

  console.log("acquisti", ordini);
  // const { downloadPdf } = usePdfAbbonamentoOpen();

  return (
    <>
      <Header data={breadcrumbs} />
      <Breadcrumbs data={breadcrumbs} />
      <div role="main" className="main-wrapper  mt-3" id="main">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <h1>I tuoi ordini</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Steps selected={4} />
            </div>
          </div>
          {isLoading ? (
            <div className="row">
              <div className="col-12">
                <div className="text-center my-5">
                  <Icon name="spinner" className="icon--big icon--animated" />
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-gray px-4 py-5 mb-4">
              {ordini?.acquisti?.length > 0 && (
                <>
                  <div className="row mb-3 ">
                    <div className="col-12">
                      <h2 className="h3 graphic">
                        <span className="graphic__label graphic__label--gray-light">
                          Prenotazioni
                        </span>
                        <span className="graphic__line">&nbsp;</span>
                      </h2>
                    </div>
                    {ordini?.acquisti?.length === 0 && (
                      <div className="row">
                        <div className="col-12">
                          Nessuna prenotazione presente
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {ordini?.acquisti?.map((item) => (
                      <Fragment key={item.id_carrello}>
                        <div className="separator">
                          <strong>Acquisto del {item.data}</strong>
                        </div>

                        <div className="row mt-2">
                          <div className="col-lg-12">
                            <div className="row d-none d-md-flex mb-2">
                              <div className="col-4">
                                <strong>Evento</strong>
                              </div>
                              <div className="col-3">
                                <strong>Giorno</strong>
                              </div>
                              <div className="col-3">
                                <strong>Partecipanti</strong>
                              </div>
                              <div className="col-2">
                                <strong>PDF</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                        {item.book.map((book, index) => (
                          <div key={book.id_book} className="row">
                            <div className="col-12 col-md-4">
                              {" "}
                              <Link
                                to={`${linkProgramma}/${slugifyEventTitle(
                                  book.titolo,
                                )}`}
                              >
                                {book.titolo}
                              </Link>
                            </div>

                            <div className="col-12 col-md-3">
                              {getDayDesc(book.data_book)} {book.orario_book}
                            </div>
                            <div className="col-12 col-md-3">
                              {book.titoli.map((titolo) => {
                                return (
                                  <div key={titolo.codice}>
                                    {(titolo.intestatarioOnline?.nome ||
                                      titolo.intestatario?.nome) ??
                                      ""}{" "}
                                    {(titolo.intestatarioOnline?.cognome ||
                                      titolo.intestatario?.cognome) ??
                                      ""}
                                  </div>
                                );
                              })}
                            </div>

                            <div className="col-12 col-md-2">
                              {index === 0 && (
                                <PdfButton
                                  data={{
                                    type: "prenotazioni",
                                    code: item.code,
                                  }}
                                  className="graphic__download-btn"
                                >
                                  <strong>Scarica l'ordine</strong>
                                </PdfButton>
                              )}
                            </div>
                          </div>
                        ))}
                      </Fragment>
                    ))}
                  </div>
                </>
              )}
              {ordini?.titoli && (
                <>
                  <div className="row mt-5 mb-3 ">
                    <div className="col-12">
                      <h2 className="h3 graphic">
                        <span className="graphic__label graphic__label--gray-light">
                          Titoli acquistati online
                        </span>
                        <span className="graphic__line">&nbsp;</span>
                      </h2>
                    </div>
                    {ordini?.titoli.length === 0 && (
                      <div className="row">
                        <div className="col-12">Nessun acquisto presente</div>
                      </div>
                    )}
                  </div>
                  {ordini?.titoli.length > 0 && (
                    <div className="row mb-2 ">
                      <div className="col-lg-12">
                        <div className="row d-none d-sm-flex mb-2">
                          <div className="col-4">
                            <strong>Tipo</strong>
                          </div>
                          <div className="col-3">
                            <strong>Intestatario</strong>
                          </div>
                          <div className="col-3">
                            <strong>Periodo</strong>
                          </div>
                          <div className="col-2">
                            <strong>PDF</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {ordini.titoli?.map((item, index) => (
                    <div className="row py-2" key={index}>
                      <div className="col-12 col-md-4">
                        {item.descrizione}{" "}
                        {item.descrizioneCausale &&
                          `(${item.descrizioneCausale})`}
                      </div>
                      <div className="col-12 col-md-3">
                        {item.intestatarioOnline?.nome ?? ""}{" "}
                        {item.intestatarioOnline?.cognome ?? ""}
                      </div>
                      <div className="col-12 col-md-3">
                        {item.specie === "O"
                          ? "Tutte le giornate del Festival"
                          : `${getTicketDesc(item.tck)}`}
                      </div>
                      <div className="col-12 col-md-2">
                        {/* <a className="no-blank" href={item.pdf}>
                                <strong>Scarica l'ordine in pdf</strong>
                              </a> */}
                        {item.titolo_stato === "valido" ? (
                          <PdfButton
                            data={{
                              type: "abbonamento-open",
                              barcode: item.barcode,
                            }}
                            className="graphic__download-btn"
                          >
                            <strong>Scarica l'ordine</strong>
                          </PdfButton>
                        ) : (
                          <strong>Titolo annullato</strong>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}
              {ordini?.titoli_portafoglio.length > 0 && (
                <>
                  <div className="row mt-5 mb-3 ">
                    <div className="col-12">
                      <h2 className="h3 graphic">
                        <span className="graphic__label graphic__label--gray-light">
                          Titoli collegati
                        </span>
                        <span className="graphic__line">&nbsp;</span>
                      </h2>
                    </div>
                    {ordini?.titoli_portafoglio.length === 0 && (
                      <div className="row">
                        <div className="col-12">Nessun acquisto presente</div>
                      </div>
                    )}
                  </div>
                  <div className="row mb-2 ">
                    <div className="col-lg-12">
                      <div className="row d-none d-sm-flex mb-2">
                        <div className="col-4">
                          <strong>Tipo</strong>
                        </div>
                        <div className="col-3">
                          <strong>Intestatario</strong>
                        </div>
                        <div className="col-3">
                          <strong>Periodo</strong>
                        </div>
                        <div className="col-2">
                          <strong>PDF</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  {ordini.titoli_portafoglio?.map((item, index) => (
                    <div className="row py-2" key={index}>
                      <div className="col-12 col-md-4">
                        {item.descrizione}{" "}
                        {item.descrizioneCausale &&
                          `(${item.descrizioneCausale})`}
                      </div>
                      <div className="col-12 col-md-3">
                        {(item.intestatarioOnline?.nome ||
                          item.intestatario?.nome) ??
                          ""}{" "}
                        {(item.intestatarioOnline?.cognome ||
                          item.intestatario?.cognome) ??
                          ""}
                      </div>
                      <div className="col-12 col-md-3">
                        {item.data
                          ? `${getTicketDesc(item.tck)}`
                          : "Tutte le giornate del Festival"}
                      </div>
                      <div className="col-12 col-md-2">Non disponibile</div>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Ordini;
